"use client";
import React, { useEffect, useState } from "react";
// import ProductSliderContainer from "./ProductSliderContainer";

// import Delivey from "../../Delivey/Delivey";

import ProductDetailsSpecifications from "./ProductDetailsSpecifications";

import ProductReview from "../ProductReivew";
// import ProductAnswer from "../../ProductAnswer";

import ProductShowMore from "./ProductShowMore";

// import {  MobileItemContainer } from "../../../commComponents";
// import Lazyload from "react-lazyload";
import VideoList from "./VideoList";
import {
    useCommonContext,
    useProductDetailsContext,
    useReviewAndFqContext,
} from "@/src/provider";
import stl from "./productAccordion.module.scss";
import { commentList } from "@/store";
import { packageInfo } from "@/store";
import QuillContent from "./QuillContent";
import { getSiteConfiguration } from "@/src/utils/configUtils";
import ProductSliderContainer from "./ProductSliderContainer";
import { CommonDataProps } from "@/src/provider/Common/Provider";
interface IProps extends Partial<CommonDataProps> {
    H5Details?: any;
}

const ProductAccordionClient: React.FC<React.PropsWithChildren<IProps>> = (
    props,
) => {
    const [getCommentPhotoList] = commentList.useCommentListStore((state) => [
        state.getCommentPhotoList,
    ]);
    const [productDetail] = useProductDetailsContext((state) => [
        state.productDetail,
    ]);
    // const { H5Details = {} } = props;

    useEffect(() => {
        getCommentPhotoList(productDetail.products_id!, {
            per_page: 16,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // let isShowMoreDetail =
    //     productDetail.products_description_relation?.detailed_description;

    // let { frameDetails = "", show, frameDetailsShow = true } = H5Details;

    // if (productDetail.products_description_relation?.detailed_description) {
    //     show = false;
    // }

    return (
        <div className={stl["product-accordion-container"]}>
            {props.children}
        </div>
    );
};

export default ProductAccordionClient;
